import React from "react";

const TextBlock = ({ config }) => {
    const text = config?.text || "";

    const parseText = (text) => {
        const parts = [];
        const regex = /<(b|h|c)>(.*?)<\/\1>/gs;

        let lastIndex = 0;
        let match;

        while ((match = regex.exec(text)) !== null) {
            // Normal text before the tag
            if (match.index > lastIndex) {
                parts.push({
                    type: "text",
                    content: text.slice(lastIndex, match.index),
                });
            }

            parts.push({
                type: match[1],
                content: match[2],
            });

            lastIndex = regex.lastIndex;
        }

        // Remaining normal text
        if (lastIndex < text.length) {
            parts.push({
                type: "text",
                content: text.slice(lastIndex),
            });
        }

        return parts;
    };

    const renderPart = (part, index) => {
        switch (part.type) {
            case "b":
                return (
                    <strong key={index}>
                        {part.content}
                    </strong>
                );

            case "h":
                return (
                    <span
                        key={index}
                        className="
                            inline-block
                            rounded-[10px]
                            bg-gray-200
                            px-2
                            py-1
                            text-black
                        "
                    >
                        {part.content}
                    </span>
                );

            case "c":
                return (
                    <code
                        key={index}
                        className="
                            inline-block
                            rounded-[10px]
                            bg-gray-200
                            px-2
                            py-1
                            font-mono
                            text-black
                            cursor-pointer
                        "
                        onClick={() => {
                            navigator.clipboard.writeText(part.content);
                        }}
                    >
                        {part.content}
                    </code>
                );

            default:
                return (
                    <React.Fragment key={index}>
                        {part.content}
                    </React.Fragment>
                );
        }
    };

    return (
        <div
            dir="rtl"
            className="
                text-base
                leading-[1.35]
                text-gray-800
                text-right
                whitespace-pre-wrap
            "
        >
            {parseText(text).map(renderPart)}
        </div>
    );
};

export default TextBlock;
